import * as fb from 'js/facebook'

export const getFacebookUserDetails = () =>
  fb.login().then(({ token }) =>
    fb.getUserDetails().then((response) => {
      response['token'] = token
      return response
    }),
  )
